<template>
  <a-date-picker v-model="newVal" v-bind="$attrs" v-on="$listeners"/>
</template>
<script>
import moment from 'moment'

export default {
  name: 'VDatePicker',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Object, Number],
      default: ''
    },
    timeStamp: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    newVal: {
      get() {
        const val = this.value ? moment(this.value * 1000) : this.value
        return val
      },
      set(val) {
        if (val && typeof val !== 'number') {
          val = moment(val).unix()
        }
        this.$emit('input', val)
      }
    }
  }
}
</script>
